module.exports = __webpack_public_path__ + "static/logo-990bac420d87ecd5c1e0812fffe52d88.svg";